// extracted by mini-css-extract-plugin
module.exports = {"iconcolumn":"iconrow-module--iconcolumn--2teIv","iconrow":"iconrow-module--iconrow--33k55"};